<!-- Navbar -->
<div
  #navbarRoot
  role="banner"
  class="cnt-navbar cnt-nav transition-transform duration-300 ease-in-out"
  [class.cnt-navbar--transparent]="transparent"
  [class.cnt-navbar--search]="searchMode"
  [style.transform]="!isNavbarVisible ? 'translateY(-150%)' : 'translateY(0)'"
>
  <div class="block-navbar">
    <div class="nav-search-wrap">
      <a routerLink="/" class="brand cnt-nav-brand" aria-label="CurbNTurf home">
        <img src="images/CNT_Logo_V_Orange.svg" width="94" alt="CurbNTurf" />
      </a>
      <div #searchWrapper class="form-block-search cnt-form relative">
        <form id="search_form" name="search-form" method="get" (submit)="$event.preventDefault(); onSearchSubmit()">
          <div class="search-location-inner">
            <button type="submit" title="Search" aria-label="Search" class="lb-search">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 24 24"
                style="enable-background: new 0 0 24 24"
              >
                <g>
                  <path
                    d="M16.5,15.5h1.1l6,6c0.6,0.6,0.6,1.5,0,2.1s-1.5,0.6-2.1,0l-6-6v-1.1l-0.4-0.4c-2,1.7-4.7,2.6-7.5,2.1c-3.9-0.7-7-3.9-7.5-7.9c-0.7-6,4.3-11,10.2-10.2c3.9,0.5,7.2,3.6,7.9,7.5c0.5,2.9-0.4,5.5-2.1,7.5L16.5,15.5z M2.8,9.1c0,3.5,2.8,6.3,6.3,6.3s6.3-2.8,6.3-6.3s-2.8-6.3-6.3-6.3C5.6,2.8,2.8,5.6,2.8,9.1z"
                  ></path>
                </g>
              </svg>
            </button>
            <input aria-label="Search location or properties"
              #searchInput
              [ngModel]="searchQuery"
              (ngModelChange)="onSearchQueryChange($event)"
              (keydown)="onSearchKeydown($event)"
              (focus)="onSearchFocus()"
              class="search-field cnt-input"
              maxlength="256"
              name="Location-2"
              [placeholder]="searchPlaceholder || (searchMode ? 'Where to?' : 'Search location or properties')"
              type="text"
              id="Location-2"
              autocomplete="off"
              role="combobox"
              aria-autocomplete="list"
              [attr.aria-controls]="autocompleteOpen ? 'nav-search-listbox' : null"
              [attr.aria-expanded]="autocompleteOpen"
            />
          </div>
        </form>

        @if (autocompleteOpen || nearMeOpen) {
          <div
            id="nav-search-listbox"
            role="listbox"
            aria-label="Search suggestions"
            class="absolute left-0 top-full mt-2 z-50 w-full min-w-[20rem] bg-white rounded-2xl border border-dark-text/10 shadow-[0_16px_40px_rgba(0,0,0,0.12)] overflow-hidden"
          >
            <ul class="max-h-[24rem] overflow-y-auto divide-y divide-dark-text/8">
              @if (nearMeOpen) {
                <li>
                  <button
                    type="button"
                    role="option"
                    aria-selected="false"
                    (mousedown)="$event.preventDefault()"
                    (click)="useMyLocation()"
                    class="w-full text-left flex items-center gap-3 px-4 py-3 hover:bg-cream/60 transition-colors"
                  >
                    <span aria-hidden="true" class="material-symbols-outlined text-lg shrink-0 text-trinidad">near_me</span>
                    <span class="font-body text-sm font-bold text-dark-text">Use my location</span>
                  </button>
                </li>
              }
              @for (result of autocompleteOpen ? autocompleteResults : []; track $index) {
                <li>
                  <button
                    type="button"
                    role="option"
                    [attr.aria-selected]="$index === activeIndex"
                    (mousedown)="selectAutocompleteResult(result)"
                    class="w-full text-left flex items-center gap-3 px-4 py-2.5 hover:bg-cream/60 transition-colors"
                    [class.bg-cream]="$index === activeIndex"
                  >
                    <span aria-hidden="true"
                      class="material-symbols-outlined text-lg shrink-0"
                      [ngClass]="!result.id ? 'text-double-muted-text' : isBoondock(result) ? 'text-jungle-green' : 'text-trinidad'"
                      >{{ result.id ? 'location_on' : 'place' }}</span
                    >
                    <div class="flex-1 min-w-0">
                      <div class="font-body text-sm text-dark-text truncate">{{ result.name }}</div>
                      <div class="text-xs text-muted-text font-body truncate">
                        {{ result.id ? (result.city ? result.city + ', ' + result.state : 'Property') : result.state }}
                      </div>
                    </div>
                  </button>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
    <div class="menu">
      <nav role="navigation" class="nav-menu cnt-nav-menu">
        <a
          routerLink="/search"
          routerLinkActive="navigation-link--active"
          class="navigation-link cnt-nav-link"
          cntCinematicRoll
        >
          Be a guest
        </a>
        <a
          routerLink="/host"
          routerLinkActive="navigation-link--active"
          class="navigation-link cnt-nav-link"
          cntCinematicRoll
        >
          Become a host
        </a>
        <a
          routerLink="/article"
          routerLinkActive="navigation-link--active"
          class="navigation-link cnt-nav-link"
          cntCinematicRoll
        >
          Articles
        </a>
        @if (user) {
          <a
            routerLink="/wishlists"
            class="navigation-link cnt-nav-link favorites-link"
            aria-label="Saved properties"
            title="Saved properties"
          >
            <span aria-hidden="true" class="material-symbols-outlined favorites-heart" style="font-variation-settings: 'FILL' 1"
              >favorite</span
            >
            @if (favoritesCount > 0) {
              <span class="favorites-badge" aria-hidden="true">{{ favoritesCount }}</span>
            }
          </a>
        }
        @if (!user) {
          <a
            routerLink="/auth/login"
            [queryParams]="signInQueryParams"
            class="navigation-link cnt-nav-link"
            cntCinematicRoll
          >
            <div class="login-wrap">
              <div class="icon-login">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14ZM12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z"
                    fill="currentColor"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.9261 20.0557C20.397 18.235 22 15.3047 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.3047 3.60301 18.235 6.07388 20.0557C6.65997 20.4742 7.1363 20.7573 7.63587 21C8.95464 21.6407 10.4354 22 12 22C13.5646 22 15.0454 21.6407 16.3641 21C16.9657 20.7015 17.4613 20.3982 17.9261 20.0557ZM17.2287 18.055C18.926 16.588 20 14.4194 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.4194 5.07401 16.588 6.77128 18.055C7.80066 16.2313 9.75654 15 12 15C14.2435 15 16.1993 16.2313 17.2287 18.055ZM15.5567 19.1679C14.8921 17.8803 13.5488 17 12 17C10.4512 17 9.10792 17.8803 8.44332 19.1679C9.51467 19.7005 10.7224 20 12 20C13.2776 20 14.4853 19.7005 15.5567 19.1679Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </div>
              <div>Log in / Sign up</div>
            </div>
          </a>
        } @else {
          <div #notificationsWrapper class="relative ml-3 hidden md:block">
            <button
              type="button"
              (click)="toggleNotifications()"
              [attr.aria-expanded]="notificationsOpen"
              aria-label="Notifications"
              class="relative w-10 h-10 rounded-full bg-white border border-dark-text/10 text-dark-text flex items-center justify-center hover:border-trinidad hover:text-trinidad transition-colors"
            >
              <span aria-hidden="true"
                class="material-symbols-outlined text-xl"
                [style.font-variation-settings]="unreadNotifications > 0 ? '\'FILL\' 1' : null"
                >notifications</span
              >
              @if (unreadNotifications > 0) {
                <span
                  class="absolute -top-1 -right-1 min-w-[1.1rem] h-[1.1rem] px-1 rounded-full bg-trinidad text-white text-[0.6rem] font-button font-bold flex items-center justify-center"
                >
                  {{ unreadNotifications > 9 ? '9+' : unreadNotifications }}
                </span>
              }
            </button>

            @if (notificationsOpen) {
              <div
                role="menu"
                aria-label="Notifications"
                class="absolute right-0 top-full mt-2 z-50 w-[22rem] max-w-[calc(100vw-2rem)] bg-white rounded-2xl border border-dark-text/10 shadow-[0_16px_40px_rgba(0,0,0,0.12)] overflow-hidden"
              >
                <div class="flex items-center justify-between gap-3 px-4 py-3 border-b border-dark-text/8">
                  <div>
                    <span class="text-trinidad font-label uppercase tracking-[0.12em] text-[0.6rem] font-bold block"
                      >Recent</span
                    >
                    <h3 class="font-headline font-bold text-dark-text text-base tracking-tight leading-tight">
                      Notifications
                    </h3>
                  </div>
                  @if (unreadNotifications > 0) {
                    <button
                      type="button"
                      (click)="markAllNotificationsRead()"
                      class="text-[0.6rem] uppercase tracking-[0.12em] font-button font-bold text-trinidad hover:underline"
                    >
                      Mark all read
                    </button>
                  }
                </div>

                @if (notifications.length === 0) {
                  <div class="px-4 py-10 text-center">
                    <span class="material-symbols-outlined text-3xl text-muted-text" aria-hidden="true"
                      >notifications_off</span
                    >
                    <p class="text-sm text-muted-text font-body mt-2">You're all caught up.</p>
                  </div>
                } @else {
                  <ul class="max-h-[26rem] overflow-y-auto divide-y divide-dark-text/8">
                    @for (n of notifications; track n.id) {
                      <li>
                        <button
                          type="button"
                          (click)="onNotificationClick(n)"
                          [class.bg-trinidad]="false"
                          class="w-full text-left flex items-start gap-3 px-4 py-3 hover:bg-cream/60 transition-colors relative"
                          [class.bg-cream]="!n.read"
                        >
                          <span
                            class="shrink-0 w-9 h-9 rounded-full inline-flex items-center justify-center"
                            [ngClass]="notifyIconClass(n)"
                            [ngStyle]="notifyIconStyle(n)"
                          >
                            <span aria-hidden="true"
                              class="material-symbols-outlined text-base"
                              style="font-variation-settings: 'FILL' 1"
                              >{{ n.icon }}</span
                            >
                          </span>
                          <div class="flex-1 min-w-0">
                            <div class="font-body text-sm text-dark-text leading-tight" [class.font-bold]="!n.read">
                              {{ n.title }}
                            </div>
                            <div class="text-xs text-muted-text font-body mt-0.5 truncate">{{ n.subtitle }}</div>
                            <div
                              class="text-[0.6rem] uppercase tracking-[0.1em] font-button font-bold text-muted-text mt-1"
                            >
                              {{ notifyTimeLabel(n.timestamp) }}
                            </div>
                          </div>
                          @if (!n.read) {
                            <span class="absolute right-3 top-3 w-2 h-2 rounded-full bg-trinidad"></span>
                          }
                        </button>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          </div>
          <div #userMenuWrapper class="relative ml-3">
            <button
              type="button"
              (click)="toggleUserMenu()"
              [attr.aria-expanded]="userMenuOpen"
              aria-label="Account menu"
              class="relative w-10 h-10 rounded-full bg-trinidad text-white flex items-center justify-center font-button font-bold text-sm hover:opacity-95 transition-opacity"
            >
              @if (user.photoUrl) {
                <img
                  [src]="user.photoUrl"
                  [alt]="userInitials"
                  class="absolute inset-0 w-full h-full rounded-full object-cover"
                />
              } @else {
                {{ userInitials }}
              }
              @if (user.verified) {
                <span
                  class="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-jungle-green text-white ring-2 ring-white flex items-center justify-center"
                  aria-label="Verified"
                >
                  <span aria-hidden="true" class="material-symbols-outlined text-[10px]" style="font-variation-settings: 'FILL' 1"
                    >check</span
                  >
                </span>
              }
            </button>
            @if (userMenuOpen) {
              <div
                role="menu"
                aria-label="Account menu"
                class="absolute right-0 top-full mt-2 z-50 w-72 bg-white rounded-2xl border border-dark-text/8 shadow-[0_24px_48px_rgba(0,0,0,0.14)] py-2 overflow-hidden"
              >
                <!-- Switch view (Airbnb-style top item) -->
                <button
                  type="button"
                  (click)="switchView()"
                  class="flex items-center gap-3 w-full text-left px-4 py-3 text-sm font-body font-bold text-dark-text bg-cream/40 hover:bg-cream/70 border-b border-dark-text/8 transition-colors"
                >
                  <span aria-hidden="true" class="material-symbols-outlined text-lg text-trinidad">{{
                    view === 'host' ? 'luggage' : 'campaign'
                  }}</span>
                  {{ view === 'host' ? 'Switch to traveling' : 'Switch to hosting' }}
                </button>

                <!-- todo: add back when we have identity verification -->
                <!-- Identity header -->
                <!-- <div class="px-4 py-3 border-b border-dark-text/8">
                  <div class="text-sm font-headline font-bold text-dark-text leading-tight">{{ user.firstName }} {{ user.lastName }}</div>
                  <div class="text-xs text-muted-text font-body truncate">{{ user.email }}</div>
                  @if (user.verified) {
                    <div class="mt-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-jungle-green/10 text-jungle-green text-[0.6rem] font-button uppercase tracking-[0.1em] font-bold">
                      <span aria-hidden="true" class="material-symbols-outlined text-[12px]" style="font-variation-settings: 'FILL' 1;">verified</span>
                      Verified · since {{ verifiedSinceLabel }}
                    </div>
                  }
                </div> -->

                <!-- Primary group — branches on view -->
                <div class="py-1">
                  <div
                    class="px-4 pt-1 pb-1 text-[0.6rem] uppercase tracking-[0.12em] font-button font-bold text-muted-text/70"
                  >
                    {{ view === 'host' ? 'Hosting' : 'Travel' }}
                  </div>
                  @if (view === 'host') {
                    <a
                      routerLink="/hosting"
                      (click)="closeUserMenu()"
                      class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                    >
                      <span aria-hidden="true" class="material-symbols-outlined text-lg text-dark-text">dashboard</span>
                      Hosting
                    </a>
                    <a
                      routerLink="/hosting/calendar"
                      (click)="closeUserMenu()"
                      class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                    >
                      <span aria-hidden="true" class="material-symbols-outlined text-lg text-dark-text">date_range</span>
                      Calendar
                    </a>
                    <a
                      routerLink="/properties"
                      (click)="closeUserMenu()"
                      class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                    >
                      <span aria-hidden="true" class="material-symbols-outlined text-lg text-dark-text">storefront</span>
                      Properties
                    </a>
                    <a
                      routerLink="/hosting"
                      fragment="reservations"
                      (click)="closeUserMenu()"
                      class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                    >
                      <span aria-hidden="true" class="material-symbols-outlined text-lg text-dark-text">event_available</span>
                      Reservations
                    </a>
                  } @else {
                    <a
                      routerLink="/user-dashboard/dashboard"
                      (click)="closeUserMenu()"
                      class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                    >
                      <span aria-hidden="true" class="material-symbols-outlined text-lg text-dark-text">dashboard</span>
                      Dashboard
                    </a>
                    <a
                      routerLink="/user-dashboard/trips"
                      (click)="closeUserMenu()"
                      class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                    >
                      <span aria-hidden="true" class="material-symbols-outlined text-lg text-dark-text">luggage</span>
                      Trips
                    </a>
                    <a
                      routerLink="/trip-planner"
                      (click)="closeUserMenu()"
                      class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                    >
                      <span aria-hidden="true" class="material-symbols-outlined text-lg text-dark-text">route</span>
                      Trip planner
                    </a>
                    <a
                      routerLink="/wishlists"
                      (click)="closeUserMenu()"
                      class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                    >
                      <span aria-hidden="true" class="material-symbols-outlined text-lg text-dark-text">favorite</span>
                      Favorites
                    </a>
                    @if (hasOwned) {
                      <a
                        routerLink="/hosting/calendar"
                        (click)="closeUserMenu()"
                        class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                      >
                        <span aria-hidden="true" class="material-symbols-outlined text-lg text-jungle-green">date_range</span>
                        Host calendar
                      </a>
                    }
                  }
                  <a
                    routerLink="/user-dashboard/message"
                    (click)="closeUserMenu()"
                    class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                  >
                    <span aria-hidden="true" class="material-symbols-outlined text-lg text-dark-text">forum</span>
                    <span class="flex-1">Messages</span>
                    @if (unreadMessages > 0) {
                      <span
                        class="inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full bg-trinidad text-white text-[0.65rem] font-button font-bold"
                        >{{ unreadMessages }}</span
                      >
                    }
                  </a>
                </div>

                <!-- Account group -->
                <div class="border-t border-dark-text/8 py-1">
                  <div
                    class="px-4 pt-1 pb-1 text-[0.6rem] uppercase tracking-[0.12em] font-button font-bold text-muted-text/70"
                  >
                    Account
                  </div>
                  <a
                    routerLink="/user-dashboard/user-profile"
                    (click)="closeUserMenu()"
                    class="flex items-center gap-3 px-4 py-2.5 text-sm font-body text-dark-text hover:bg-cream/60 transition-colors"
                  >
                    <span aria-hidden="true" class="material-symbols-outlined text-lg text-muted-text">manage_accounts</span>
                    Account settings
                  </a>
                  @if (view !== 'host') {
                    <a
                      routerLink="/user-dashboard/user-profile"
                      fragment="rig"
                      (click)="closeUserMenu()"
                      class="flex items-center gap-3 px-4 py-2.5 text-sm font-body text-dark-text hover:bg-cream/60 transition-colors"
                    >
                      <span aria-hidden="true" class="material-symbols-outlined text-lg text-muted-text">rv_hookup</span>
                      My Rig
                    </a>
                  }
                  <a
                    routerLink="/friend"
                    (click)="closeUserMenu()"
                    class="flex items-center gap-3 px-4 py-2.5 text-sm font-body text-dark-text hover:bg-cream/60 transition-colors"
                  >
                    <span aria-hidden="true" class="material-symbols-outlined text-lg text-muted-text">card_giftcard</span>
                    Refer a friend
                  </a>
                  <a
                    routerLink="/faq"
                    (click)="closeUserMenu()"
                    class="flex items-center gap-3 px-4 py-2.5 text-sm font-body text-dark-text hover:bg-cream/60 transition-colors"
                  >
                    <span aria-hidden="true" class="material-symbols-outlined text-lg text-muted-text">help</span>
                    Help Center
                  </a>
                </div>

                <!-- Sales group — sales/admin roles only -->
                @if (hasGrowAccess) {
                  <div class="border-t border-dark-text/8 py-1">
                    <div
                      class="px-4 pt-1 pb-1 text-[0.6rem] uppercase tracking-[0.12em] font-button font-bold text-muted-text/70"
                    >
                      Sales
                    </div>
                    <a
                      routerLink="/sales/clients"
                      (click)="closeUserMenu()"
                      class="flex items-center gap-3 px-4 py-2.5 text-sm font-body font-bold text-dark-text hover:bg-cream/60 transition-colors"
                    >
                      <span aria-hidden="true" class="material-symbols-outlined text-lg text-trinidad">groups</span>
                      Clients
                    </a>
                  </div>
                }

                <!-- Become a host promo — guests only -->
                @if (view !== 'host') {
                  <a
                    routerLink="/host"
                    (click)="closeUserMenu()"
                    class="block border-t border-dark-text/8 px-4 py-3 hover:bg-cream/60 transition-colors"
                  >
                    <div class="flex items-center gap-3">
                      <span
                        class="w-9 h-9 rounded-full bg-trinidad/10 inline-flex items-center justify-center shrink-0"
                      >
                        <span aria-hidden="true" class="material-symbols-outlined text-base text-trinidad">campaign</span>
                      </span>
                      <div class="flex-1 min-w-0">
                        <div class="text-sm font-body font-bold text-dark-text leading-tight">Become a host</div>
                        <div class="text-xs text-muted-text font-body leading-snug mt-0.5">
                          Earn from your land — pull in extra income.
                        </div>
                      </div>
                    </div>
                  </a>
                }

                <!-- Sign out -->
                <button
                  type="button"
                  (click)="signOut()"
                  class="flex items-center gap-3 w-full text-left px-4 py-2.5 text-sm font-body text-dark-text hover:bg-cream/60 border-t border-dark-text/8 transition-colors"
                >
                  <span aria-hidden="true" class="material-symbols-outlined text-lg text-muted-text">logout</span>
                  Log out
                </button>
              </div>
            }
          </div>
        }
      </nav>
      <!-- Mode badge below 992px, where the avatar menu is hidden and nothing
           else in the header shows the current view. Hosting only; traveling
           is the default and stays unmarked. The breakpoint matches the 991px
           rule that hides .nav-menu. -->
      @if (user && view === 'host') {
        <span
          class="hidden max-[991px]:inline-flex items-center gap-1 mr-2 px-2.5 py-1 rounded-full bg-jungle-green text-white text-[0.6rem] uppercase tracking-[0.12em] font-button font-bold leading-none"
        >
          <span class="material-symbols-outlined text-[14px]" aria-hidden="true">storefront</span>
          <span class="sr-only">Current mode: </span>Hosting
        </span>
      }
      <button
        type="button"
        (click)="toggleMobileNav()"
        class="nav-menu-button"
        aria-label="Toggle menu"
        [attr.aria-expanded]="mobileNavOpen"
      >
        <span aria-hidden="true" class="material-symbols-outlined">{{ mobileNavOpen ? 'close' : 'menu' }}</span>
      </button>
    </div>
  </div>

  <!-- Mobile drawer (below 992px).
       The avatar menu, which holds the host/traveler switch, lives inside
       .nav-menu and is hidden below 992px, so on phones and tablets this drawer
       is the only header menu. It must reflect the current view: it carries the
       switch, and its links branch on view the same way the avatar menu does.
       Before this, it always showed traveler links, so a host tapping
       "Dashboard" landed on the guest dashboard. -->
  @if (mobileNavOpen) {
    <nav class="block-navbar nav-menu-mobile" role="navigation">
      @if (!user) {
        <a
          routerLink="/search"
          routerLinkActive="navigation-link--active"
          (click)="closeMobileNav()"
          class="navigation-link"
          >Be a guest</a
        >
        <a
          routerLink="/host"
          routerLinkActive="navigation-link--active"
          (click)="closeMobileNav()"
          class="navigation-link"
          >Become a host</a
        >
        <a
          routerLink="/article"
          routerLinkActive="navigation-link--active"
          (click)="closeMobileNav()"
          class="navigation-link"
          >Articles</a
        >
        <a routerLink="/auth/login" [queryParams]="signInQueryParams" (click)="closeMobileNav()" class="navigation-link"
          >Log in / Sign up</a
        >
      } @else {
        <!-- Mode switch: same action as the avatar menu's top item. -->
        <button
          type="button"
          (click)="switchView(); closeMobileNav()"
          class="navigation-link text-left flex items-center gap-2 font-bold"
        >
          <span class="material-symbols-outlined text-lg text-trinidad" aria-hidden="true">{{
            view === 'host' ? 'luggage' : 'campaign'
          }}</span>
          {{ view === 'host' ? 'Switch to traveling' : 'Switch to hosting' }}
        </button>
        <div class="h-px bg-dark-text/10 my-1" aria-hidden="true"></div>

        <div class="px-2 pt-2 pb-1 text-[0.6rem] uppercase tracking-[0.14em] font-button font-bold text-muted-text">
          {{ view === 'host' ? 'Hosting' : 'Traveling' }}
        </div>
        @if (view === 'host') {
          <a routerLink="/hosting" (click)="closeMobileNav()" class="navigation-link">Hosting dashboard</a>
          <a routerLink="/properties" (click)="closeMobileNav()" class="navigation-link">Properties</a>
          <a routerLink="/hosting/calendar" (click)="closeMobileNav()" class="navigation-link">Calendar</a>
          <a routerLink="/hosting" fragment="earnings" (click)="closeMobileNav()" class="navigation-link">Earnings</a>
        } @else {
          <a routerLink="/search" (click)="closeMobileNav()" class="navigation-link">Explore</a>
          <a routerLink="/user-dashboard/dashboard" (click)="closeMobileNav()" class="navigation-link">Dashboard</a>
          <a routerLink="/user-dashboard/trips" (click)="closeMobileNav()" class="navigation-link">My trips</a>
          <a routerLink="/trip-planner" (click)="closeMobileNav()" class="navigation-link">Trip planner</a>
          <a routerLink="/wishlists" (click)="closeMobileNav()" class="navigation-link">Favorites</a>
        }
        <a routerLink="/user-dashboard/message" (click)="closeMobileNav()" class="navigation-link"
          >Messages
          @if (unreadMessages > 0) {
            <span class="ml-1 text-trinidad font-bold">({{ unreadMessages }})</span>
          }
        </a>
        @if (hasGrowAccess) {
          <a routerLink="/sales/clients" (click)="closeMobileNav()" class="navigation-link">Clients</a>
        }

        <div class="h-px bg-dark-text/10 my-1" aria-hidden="true"></div>
        <a
          routerLink="/article"
          routerLinkActive="navigation-link--active"
          (click)="closeMobileNav()"
          class="navigation-link"
          >Articles</a
        >
        @if (view !== 'host') {
          <a
            routerLink="/host"
            routerLinkActive="navigation-link--active"
            (click)="closeMobileNav()"
            class="navigation-link"
            >Become a host</a
          >
        }
        <button type="button" (click)="signOut(); closeMobileNav()" class="navigation-link text-left">Sign out</button>
      }
    </nav>
  }
</div>
